import { BLOCK_OVERVIEW_TOKEN } from 'styles/theme';

/**
 * Layout tokens for Builder Mode V1 toolbar (Figma node 75644:18050).
 * Colors: Chakra semantic tokens from `styles/theme/index.ts` (`blockOverview.*`).
 */
export const BUILDER_MODE_V1_LAYOUT = {
  horizontalPadding: { base: 4, md: 10, xl: '72px' },
  paddingTop: '24px',
  paddingBottom: '12px',
  titleActionsGap: '32px',
  actionsGap: '16px',
  actionButtonRadius: '10px',
  actionButtonHeight: '36px',
  actionButtonPaddingX: '12px',
  baselineButtonWidth: '160px',
  /** Scenario popover (Figma node 75644:19356) */
  scenarioPopoverWidth: '197px',
  scenarioPopoverRadius: '16px',
  scenarioPopoverShadow: '0px 4px 24px rgba(0, 0, 0, 0.25)',
  /** Add scenario side panel (Figma node 75644:19356) */
  addScenarioPanelWidth: '477px',
  addScenarioPanelRadius: '16px',
  addScenarioPanelPadding: '20px',
  titleFontSize: '24px',
  titleLineHeight: '27px',
  iconSize: 16,
  chevronWidth: 9,
  chevronHeight: 6,
  builderToggleGap: '12px',
  /** Sub-toolbar (Figma node 75644:18026) */
  subToolbarMinHeight: '42px',
  subToolbarTabPaddingX: '16px',
  subToolbarTabPaddingY: '12px',
  subToolbarTabFontSize: '13px',
  subToolbarTabRadius: '12px',
  addIndicatorButtonWidth: '179px',
  addIndicatorButtonHeight: '32px',
  addIndicatorButtonPaddingX: '16px',
  addIndicatorButtonPaddingY: '9px',
  /** Formula toolbar (Figma node 75644:18611) */
  formulaToolbarRadius: '12px',
  formulaToolbarGap: '20px',
  formulaToolbarPadding: '8px',
  formulaSectionGap: '16px',
  formulaControlsGap: '12px',
  /** Width for the data-type dropdown. It used to flex inside a fixed 443px
      group, which stretched a two-word label across half the toolbar. */
  dataTypeDropdownWidth: '150px',
  /** The format toggles read as one segmented control, so they sit tighter
      together than the 12px used between unrelated controls. */
  formatToggleGap: '4px',
  formatToggleWidth: '44px',
  formatToggleHeight: '40px',
  toolbarFontFamily: 'Roboto Regular',
  /** Map tab node chips (Figma node 75644:18453) */
  mapSameBlockChipBg: '#8B5CF6',
  mapOtherBlockChipBg: '#3BA7FA',
  /** Max table card height — leaves room for V1 headers + toolbars */
  tablePanelMaxHeight: 'calc(100vh - 320px)',
  /** Gap between table card and Add New Indicator row (Figma node 75974:10216) */
  addIndicatorTableGap: '7px',
  /** Input panel (Figma node 75644:16399) */
  inputPanelRadius: '16px',
  inputPanelPadding: '20px',
  inputPanelGap: '20px',
  inputPanelShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
  inputPanelTitleFontSize: '20px',
  inputPanelCloseButtonSize: '32px',
  inputPanelChartRadius: '8px',
  inputTypeTabHeight: '32px',
  inputTypeTabRadius: '12px',
  inputTypeTabFontSize: '12px',
  inputTypeTabPaddingX: '20px',
  inputPanelTableToolbarGap: '12px',
  inputPanelTableRadius: '12px',
  inputPanelDimensionColWidth: '131px',
  inputPanelValueColWidth: '122px',
  inputPanelRowHeight: '40px',
  inputPanelHeaderPurple: '#8B5CF6',
  inputPanelHeaderMid: '#C4B5FD',
} as const;

/** @see BLOCK_OVERVIEW_TOKEN in `styles/theme/index.ts` */
export const BUILDER_MODE_V1_TOKENS = BLOCK_OVERVIEW_TOKEN;

export type BuilderModeV1ColorToken =
  typeof BUILDER_MODE_V1_TOKENS[keyof typeof BUILDER_MODE_V1_TOKENS];
